exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{padding:0;margin:0;font-family:PT Mono,serif;color:#fff}canvas{display:block;background-color:#000;position:absolute;top:0;bottom:0;left:0;right:0;width:100%;height:100%}.current-score{left:20px}.top-score{right:20px}.score{font-size:20px}.controls,.score{display:block;position:absolute;top:15px;z-index:1}.controls{transform:translate(-50%);font-size:11px;line-height:1.6}.controls,.endgame{left:50%;text-align:center}.endgame{position:absolute;top:50%;transform:translate(-50%,-50%);padding:16px;z-index:1}button{border:4px solid #fff;background-color:transparent;color:#fff;font-size:20px;padding:10px 20px;margin:10px;font-family:PT Mono,serif;cursor:pointer}button:hover{background-color:#fff;color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/style.css
// module id = 93
// module chunks = 0